// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"checkbox__msignaturepad___3qDmW","m-signature-pad--body":"checkbox__m-signature-pad--body___q0m1e","m-signature-pad--footer":"checkbox__m-signature-pad--footer___DAo2l","description":"checkbox__description___3IGSR","button":"checkbox__button___1cvTI","clear":"checkbox__clear___1ivE7","save":"checkbox__save___1lktw","m-signature-pad":"checkbox__m-signature-pad___3SdXC","github":"checkbox__github___2Kws1","check":"checkbox__check___3p2-1","checked":"checkbox__checked___35sdg","text":"checkbox__text___1iBBh","large":"checkbox__large___90jVE"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/styles/checkbox.scss
// module id = C7qr
// module chunks = client